import {
  extractBoardBasisCode,
  formatBoardBasisLabel,
  HOTEL_BOARD_BASIS_NOT_SPECIFIED_HE,
  pickFirstNonEmptyTrimmed,
} from "./orders/hotelBoardBasis";

/**
 * Raw board/basis from an LDS room row — same field order as agent RoomsSelector / PackagesProfile.
 */
export function pickLdsRoomBoardBasisRaw(room) {
  if (!room || typeof room !== "object") return null;
  return pickFirstNonEmptyTrimmed([
    room.boardBasis,
    room.BoardBasis,
    room.board_basis,
    room.roombasis,
    room.roomBasis,
    room.RoomBasis,
    room.board,
    room.Board,
    room.mealPlan,
    room.MealPlan,
    room.basis,
    room.pension,
    room.accommodationBasis,
  ]);
}

/**
 * Hebrew display label for vacation-package board — SSOT aligned with agent `boards.*` / hotelBoardBasis.
 */
export function resolveVacationPackageRoomBoardBasisSsot(room, options = {}) {
  const {
    packageId = null,
    roomIndex = null,
    roomName = null,
    source = "room",
    emitTrace = true,
    traceEmitter = null,
  } = options;

  const rawBoardBasis = pickLdsRoomBoardBasisRaw(room);
  const boardCode = extractBoardBasisCode(rawBoardBasis);
  const displayedBoardBasis = formatBoardBasisLabel(rawBoardBasis);
  const normalizedBoardBasis =
    boardCode && displayedBoardBasis !== HOTEL_BOARD_BASIS_NOT_SPECIFIED_HE
      ? formatBoardBasisLabel(boardCode)
      : displayedBoardBasis;

  const payload = {
    packageId: packageId != null ? String(packageId) : null,
    roomIndex,
    roomName: roomName ?? null,
    rawBoardBasis: rawBoardBasis ?? "",
    normalizedBoardBasis:
      normalizedBoardBasis === HOTEL_BOARD_BASIS_NOT_SPECIFIED_HE ? "" : normalizedBoardBasis,
    displayedBoardBasis:
      displayedBoardBasis === HOTEL_BOARD_BASIS_NOT_SPECIFIED_HE ? "" : displayedBoardBasis,
    boardCode: boardCode || "",
    source,
  };

  if (emitTrace && typeof traceEmitter === "function") {
    traceEmitter(payload);
  }

  return payload;
}

/** Package-level board (hotel / fullDeal) — same SSOT, no per-room index. */
export function resolveVacationPackageHotelBoardBasisSsot(hotelOrDeal, options = {}) {
  const raw =
    typeof hotelOrDeal === "object" && hotelOrDeal != null
      ? pickLdsRoomBoardBasisRaw(hotelOrDeal) ??
        pickFirstNonEmptyTrimmed([hotelOrDeal.board, hotelOrDeal.roombasis])
      : hotelOrDeal;
  return resolveVacationPackageRoomBoardBasisSsot(
    raw != null ? { boardBasis: raw } : {},
    { ...options, source: options.source ?? "hotel" },
  );
}
